<template>
    <div class="offcanvas-container">
      <div id="main-curtain" class="overly-mask" :class="{'is-visible': showOffCanve}" @click="offCanvasClose()"></div>
      <div class="offcanves" style="height: 100%;z-index: 9900">
        <div class="offcanves-box">
          <router-link v-if="user" :to="{ name: 'dashboard' }" class="account-link">
            <div class="user-ava">
              <img :src="user.avatar_url" :alt="user.nickname">
            </div>
            <div class="user-info">
              <h6 class="user-name">{{ user.nickname }}</h6>
              <span class="text-sm text-white opacity-60">{{ user.email }}</span>
            </div>
          </router-link>
          <nav class="offcanvas-menu">
            <ul class="menu">
              <li class="active" v-if="!user" >
                    <span>
                      <router-link :to="{ name: 'login' }">
                        <span>登录/注册</span>
                      </router-link>
                    </span>
              </li>
              <li class="active">
                    <span>
                        <router-link to="/">
                            <span>{{ $t('nav.home') }}</span>
                        </router-link>
                    </span>
              </li>

              <!-- 導航欄 -->
              <li class="has-children menu-nav">
                    <span>
                        <a href="javascript:void(0);">
                            <span>{{ $t('nav.product_promotion') }}</span>
                        </a>
                        <span class="sub-menu-toggle"></span>
                    </span>
                <ul class="offcanvas-submenu">
                  <back-item />
                  <li>
                    <router-link :to="{ name: 'products:new' }">{{ $t('nav.new_product') }}</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'products:recommend' }">{{ $t('nav.recommend_product') }}</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'products:hot-sales' }">{{ $t('nav.hot_sales_product') }}</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'products' }">{{ $t('nav.all_product') }}</router-link>
                  </li>
                </ul>
              </li>


              <li class="has-children menu-nav">
                    <span>
                        <a href="javascript:void(0);">
                            <span>{{ $t('nav.proxy_buy') }}</span>
                        </a>
                    </span>
                <ul class="offcanvas-submenu">
                  <back-item />
                  <li>
                    <router-link :to="{ name: 'rakuten' }">{{ $t('shop_names.rakuten') }}</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'yahoo_jp' }">{{ $t('shop_names.yahoo_jp') }}</router-link>
                  </li>
                  <li>
                    <a href="javascript:void(0)" onclick="alert('coming soon!')">{{ $t('shop_names.amazon_jp') }}</a>
                    <!--<router-link :to="{ name: 'amazon' }">{{ $t('shop_names.amazon_jp') }}</router-link>-->
                  </li>
                </ul>
              </li>
              <!--<li class="menu-nav">-->
              <!--<span>-->
              <!--<router-link to="/">-->
              <!--<span>Amazon</span>-->
              <!--</router-link>-->
              <!--</span>-->
              <!--</li>-->
              <li class="menu-nav">
                    <span>
                         <router-link to="/">
                            <span>{{ $t('nav.shop') }}</span>
                        </router-link>
                    </span>
              </li>
              <li class="menu-nav">
                    <span>
                         <router-link to="/">
                            <span>{{ $t('nav.forwarding') }}</span>
                        </router-link>
                    </span>
              </li>

              <!--<li class="menu-category" v-if="source.length" :class="{ 'has-children': source.length }">-->
              <!--<span>-->
              <!--<a href="javascript:;">-->
              <!--<span @click.prevent="subMenuToggle($event)">-->
              <!--<span>{{ $t('product.source') }}</span>-->
              <!--<span class="sub-menu-toggle" style="border-left: none"></span>-->
              <!--</span>-->
              <!--</a>-->
              <!--</span>-->
              <!--<ul class="offcanvas-submenu">-->
              <!--<back-item />-->
              <!--<li v-for="sources in source"-->
              <!--:key="sources.id"-->
              <!--&gt;-->
              <!--<router-link :to="{ name: 'source', params: { id: sources.id }}">-->
              <!--{{ sources.language_name }}-->
              <!--</router-link>-->
              <!--</li>-->
              <!--</ul>-->
              <!--</li>-->

              <!-- 分類 -->
              <li class="menu-category"
                  v-if="categories.length"
                  v-for="category in categories"
                  :key="category.id"
                  :class="{ 'has-children': category.nodes && category.nodes.length }"
              >
                    <span>
                        <router-link :to="{ name: 'category', params: { id: category.id } }">
                            <span>{{ category.name }}</span>
                        </router-link>
                    </span>
                <!--<ul class="offcanvas-submenu" v-if="category.nodes && category.nodes.length">-->
                <!--<li v-for="secondCategory in category.nodes"-->
                <!--:key="secondCategory.id"-->
                <!--:class="{ 'has-children': secondCategory.nodes && secondCategory.nodes.length }"-->
                <!--&gt;-->
                <!--&lt;!&ndash; 三級分類 &ndash;&gt;-->
                <!--<template v-if="secondCategory.nodes && secondCategory.nodes.length">-->
                <!--<span>-->
                <!--<router-link :to="{ name: 'category', params: { id: secondCategory.id } }">-->
                <!--<span>{{ secondCategory.name }}</span>-->
                <!--</router-link>-->
                <!--</span>-->
                <!--<ul class="offcanvas-submenu">-->
                <!--<li v-for="thirdCategory in secondCategory.nodes"-->
                <!--:key="thirdCategory.id"-->
                <!--&gt;-->
                <!--<router-link :to="{ name: 'category', params: { id: thirdCategory.id }}">-->
                <!--{{ thirdCategory.name }}-->
                <!--</router-link>-->
                <!--</li>-->
                <!--</ul>-->
                <!--</template>-->
                <!--<template v-else>-->
                <!--<router-link :to="{ name: 'category', params: { id: secondCategory.id }}">-->
                <!--{{ secondCategory.name }}-->
                <!--</router-link>-->
                <!--</template>-->

                <!--</li>-->
                <!--</ul>-->
              </li>
              <li>
                <router-link :to="{ name: 'proxy-request' }">{{ $t('nav.proxy_request') }}</router-link>
              </li>
            </ul>
          </nav>
          <template v-if="user">
            <div class="cancel">
              <div>
                <router-link :to="{ name: 'dashboard' }" class="account-link">
                  {{ $t('user.information') }}
                </router-link>
              </div>
              <div>
                <a href="/logout" @click.prevent="logout()">
                  {{ $t('user.logout') }}
                </a>
              </div>
            </div>

          </template>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Velocity from 'velocity-animate';
  import BackItem from './BackItem.vue';

  /* globals $ */

  export default {
    name: 'OffCanvas',
    data() {
      return {
        openSubMenu: false,
        current: null,
      };
    },
    methods: {
      offCanvasClose() {
        this.$store.dispatch('offCanvasClose');
      },
      logout() {
        this.$store.dispatch('logout')
          .then(() => {
            if (this.$route.meta.needAuthenticate) {
              this.$router.push({ name: 'home' });
            }
        });
      },
      subMenuToggle($event) {
        const target = !$event.target.localName === 'span' ? $($event.target).parent() : $($event.target);
        Velocity(
          document.getElementsByClassName('offcanvas-container')[0],
          {
            scrollTop: 0,
          },
          {
            offset: 0,
            duration: 0,
            easing: 'easeOutExpo',
            mobileHA: false,
          },
        );

        const parent = target.parent().parent().parent();
        parent.addClass('off-view');
        target.parent().parent().find('> .offcanvas-submenu')
          .addClass('in-view');
        $event.preventDefault();
        return false;
      },
    },
    computed: {
      ...mapState({
        showOffCanve: state => state.app.offcanve,
        user: state => state.user.identity,
        categories: state => state.product.categories,
        source: state => state.product.source,
      }),
    },
    components: {
      BackItem,
    },
  };
</script>

<style lang="scss">
   @import "../../styles/helpers/variables";
   @import "../../styles/helpers/mixins";
   .offcanves {
     position: relative;
     overflow: hidden;
   }
   .offcanves-box {
     width: 100%;
     position: absolute;
     left: 0;
     top: 0;
     overflow-x: hidden;
     overflow-y: scroll;
   }
   .overly-mask,
   .menu-overly-mask {
     background-color: $black-color;
     height: 100%;
     left: 0;
     opacity: 0;
     top: 0;
     position: fixed;
     /*transition: all 0.5s ease-in-out 0s;*/
     /*-webkit-transition: all 0.5s ease-in-out 0s;*/
     /*-o-transition: all 0.5s ease-in-out 0s;*/
     visibility: hidden;
     width: 100%;
     z-index: 9011;
   }
   .overly-mask {
    z-index: 0 !important;
   }
   .overly-mask {
     &.is-visible {
       cursor: pointer;
       opacity: 0.25;
       visibility: visible;
     }
   }

   .menu-overly-mask {
     &.is-visible {
       cursor: pointer;
       opacity: 0.55;
       visibility: visible;
     }
   }

    .offcanvas-wrapper {
        position: relative;
        background-color: $body-bg;
    }
    .offcanvas-container {
        position: fixed;
        top: 0;
        left: 0;
        width: $offcanvas-width - 30;
        height: 100%;
        background-color: $gray-darker;
        box-shadow: inset -4px 0 17px 0 rgba(0, 0, 0, .35);
        visibility: hidden;
        z-index: 9999;
        overflow-y: auto;
        &.active { visibility: visible; }
    }
    .offcanvas-header {
        padding: 28px 20px;
        border-bottom: 1px solid $border-light-color;
        .offcanvas-title {
            margin-bottom: 0;
            color: rgba($white-color, .5);
            font: {
                size: $font-size-base;
                weight: $font-weight-headings;
            }
        }
    }
    .account-link {
        display: flex;
        width: 100%;
        padding: 10px 18px;
        /*transition: background-color .3s;*/
        border-bottom: 1px solid $border-light-color;
        background-color: darken($gray-darker, 3%);
        text-decoration: none;
        .user-ava,
        .user-info {
            display: table-cell;
            vertical-align: middle;
            overflow: hidden;
        }
        .user-ava {
            width: 48px;
            > img {
                display: block;
                width: 48px;
                padding: 3px;
                border: 1px solid $border-light-color;
                border-radius: 50%;
            }
        }
        .user-info {
            padding-left: 8px;
            > .user-name {
                margin-bottom: 2px;
                color: $white-color;
            }
            > span { display: block; }
        }
        &:hover { background-color: lighten($gray-darker, 1%); }
    }
    .offcanvas-menu {
        position: relative;
        width: 100%;
        overflow: hidden;
        ul {
            margin: 0;
            padding: 0;
            list-style: none;
            &.menu {
                position: relative;
                transform: translate3d(0, 0, 0);
                /*transition: all .4s cubic-bezier(.86, 0, .07, 1);*/
                /*<!--&.off-view { transform: translate3d(-100%, 0, 0); }-->*/
                /*&.in-view { transform: translate3d(0, 0, 0); }*/
            }
            li {
                display: block;
                a {
                    display: block;
                    padding: 12px 20px;
                    transition: color .3s;
                    border-bottom: 1px solid $border-light-color;
                    color: $white-color;
                    font: {
                        size: $nav-link-font-size;
                        weight: $nav-link-font-weight;
                    }
                    letter-spacing: .05em;
                    text: {
                        decoration: none;
                    }
                    &:hover { color: $nav-link-hover-color; }
                }
                &.back-btn > a {
                    background-color: darken($gray-darker, 3%);
                    color: $white-color;
                    &::before {
                        display: inline-block;
                        width: 0;
                        height: 0;
                        margin-right: 8px;
                        border-top: .32em solid transparent;
                        border-right: .37em solid;
                        border-bottom: .32em solid transparent;
                        content: '';
                        opacity: .75;
                    }
                }
                &.active > a { color: $nav-link-active-color; }
                &.has-children {
                    > span {
                        display: block;
                        position: relative;
                        width: 100%;
                        > a { padding-right: 65px; }
                    }
                    &.active > span > a { color: $nav-link-active-color; }
                    .sub-menu-toggle {
                        display: block;
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 60px;
                        height: 100%;
                        height: calc(100% - 1px);
                        transition: background-color .3s;
                        border-left: 1px solid $border-light-color;
                        color: rgba($white-color, .75);
                        cursor: pointer;
                        z-index: 1;
                        &::before {
                            display: block;
                            position: absolute;
                            top: 50%;
                            right: 25px;
                            width: 0;
                            height: 0;
                            margin-top: -5px;
                            border-top: .35em solid transparent;
                            border-bottom: .35em solid transparent;
                            border-left: .4em solid;
                            content: '';
                        }
                        &:hover {
                            background-color: rgba($white-color, .1);
                        }
                    }
                }
            }
        }
    }

    // Off-Canvas open
    .no-csstransforms3d {
        .offcanvas-wrapper,
        .navigation, .topbar {
            /*transition: left .4s ease-in-out, background-color .2s;*/
        }
        .site-backdrop {
            /*transition: left .4s ease-in-out, opacity .35s, visibility .35s;*/
        }
        .offcanvas-open {
            .offcanvas-wrapper,
            .site-backdrop,
            .navigation, .topbar { left: 290px; }
            .site-backdrop {
                opacity: .2;
                visibility: visible;
            }
        }
    }
    .csstransforms3d {
        .offcanvas-wrapper,
        .navigation, .topbar {
            /*transition: transform .4s ease-in-out, background-color .2s;*/
        }
        .site-backdrop {
            /*transition: transform .4s ease-in-out, opacity .35s, visibility .35s;*/
        }
        .offcanvas-open {
            .offcanvas-wrapper,
            .site-backdrop,
            .navigation, .topbar {
                /*transform: translate3d(0, 0, 0);*/
            }
            .site-backdrop {
                opacity: .2;
                visibility: visible;
            }
        }
    }
    .cancel{
      position: absolute;
      width: 100%;
      border:{
        bottom: 1px solid $border-light-color;
        top: 1px solid $border-light-color;
      };
      a {
        width: 100%;
        display: block;
        padding: 12px 20px;
        /*transition: color .3s;*/
        color: $white-color;
        font: {
          size: $nav-link-font-size;
          weight: $nav-link-font-weight;
        }
        letter-spacing: .05em;
        text: {
          decoration: none;
        }
        &:hover { color: $nav-link-hover-color; }
      }
    }
    @media (min-width: 992px) {
        .account-link {
            display: none!important;
        }
    }

    @media (max-width: 992px) {
        .menu-nav {
            display: none!important;
        }
    }
    @media (max-width: 320px) {
      .menu-category {
        span {
          a{
            padding: 8px 20px !important;
          }
        }
      }
    }
</style>
